<div class="w-full h-full flex flex-col gap-2 overflow-y-auto">
    <div class="w-full flex flex-col items-center justify-center gap-2">
        <h2 class="w-full oswald-font text-2xl">
            Full Team Threat Assessment
        </h2>
        <p class="w-full">
            <!-- Complete this form and discuss with at least one other member from your Threat Assessment Team for all threats. Use this form to help determine the need for a Full Team Threat Assessment. -->
        </p>
    </div>

    <div class="h-full w-full overflow-y-auto flex flex-col items-start justify-start gap-4">
        <div class="w-full h-14 shrink-0 overflow-x-auto">
            <ol class="flex items-center w-full">
                <li *ngFor="let step of stepsConfig" class="flex w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-100 after:border-4 after:inline-block">
                    <button 
                        [attr.data-tooltip-target]="step.completionProperty" data-tooltip-placement="bottom"
                        class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                        [ngClass]="{
                            'bg-nside-orange-400': currentStep === step.id,
                            'bg-orange-100': currentStep !== step.id && currentFullTeamAssessment?.[step.completionProperty] === 1,
                            'bg-gray-100': currentStep !== step.id && currentFullTeamAssessment?.[step.completionProperty] !== 1,
                            'cursor-not-allowed': step.nextStepDependency && currentFullTeamAssessment?.[step.nextStepDependency] !== 1
                        }"
                        (click)="goToStep(step.id)"
                        [disabled]="step.nextStepDependency && currentFullTeamAssessment?.[step.nextStepDependency] !== 1"
                    >
                        <lucide-icon [img]="icons.FileUser" [ngClass]="{
                            'text-white': currentStep === step.id,
                            'text-nside-orange-400': currentStep !== step.id && currentFullTeamAssessment?.[step.completionProperty] === 1,
                            'text-gray-text': currentStep !== step.id && currentFullTeamAssessment?.[step.completionProperty] !== 1
                        }"></lucide-icon>
                    </button>
                    <div [id]="step.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        {{ tooltips[step.id-1]}}
                        <div class="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </li>
                <li class="flex items-center">
                    <button 
                        [attr.data-tooltip-target]="finalStepConfig.completionProperty" data-tooltip-placement="bottom"
                        class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                        [ngClass]="{
                            'bg-nside-orange-400': currentStep === finalStepConfig.id,
                            'bg-orange-100': currentStep !== finalStepConfig.id && currentFullTeamAssessment?.[finalStepConfig.completionProperty] === 1,
                            'bg-gray-100': currentStep !== finalStepConfig.id && currentFullTeamAssessment?.[finalStepConfig.completionProperty] !== 1,
                            'cursor-not-allowed': finalStepConfig.nextStepDependency && currentFullTeamAssessment?.[finalStepConfig.nextStepDependency] !== 1
                        }"
                        (click)="goToStep(finalStepConfig.id)"
                        [disabled]="currentFullTeamAssessment?.[finalStepConfig.nextStepDependency] !== 1"
                    >
                        <lucide-icon [img]="icons.FileCheck" [ngClass]="{
                            'text-white': currentStep === finalStepConfig.id,
                            'text-nside-orange-400': currentStep !== finalStepConfig.id && currentFullTeamAssessment?.[finalStepConfig.completionProperty] === 1,
                            'text-gray-text': currentStep !== finalStepConfig.id && currentFullTeamAssessment?.[finalStepConfig.completionProperty] !== 1
                        }"></lucide-icon>
                    </button>
                    <div [id]="finalStepConfig.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        {{ tooltips[finalStepConfig.id-1]}}
                        <div class="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </li>
            </ol>
        </div>
        <div class="w-full h-full flex flex-col items-center justify-center overflow-y-auto gap-2">
            <assessment-info 
                *ngIf="this.currentStep===1 && this.currentFullTeamAssessment"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection1)="handleUpdateFullTeamAssessment($event, 1)"
            ></assessment-info>
            <threat-background
                *ngIf="this.currentStep===2"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection2)="handleUpdateFullTeamAssessment($event, 2)"
            ></threat-background>
            <section-a 
                *ngIf="this.currentStep===3"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection3)="handleUpdateFullTeamAssessment($event, 3)"
            ></section-a>
            <section-b 
                *ngIf="this.currentStep===4"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection4)="handleUpdateFullTeamAssessment($event, 4)"
            ></section-b>
            <section-c
                *ngIf="this.currentStep===5"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection5)="handleUpdateFullTeamAssessment($event, 5)"
            ></section-c>
            <section-d
                *ngIf="this.currentStep===6"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection6)="handleUpdateFullTeamAssessment($event, 6)"
            ></section-d>
            <section-e
                *ngIf="this.currentStep===7"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection7)="handleUpdateFullTeamAssessment($event, 7)"
            ></section-e>
            <section-f
                *ngIf="this.currentStep===8"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection8)="handleUpdateFullTeamAssessment($event, 8)"
            ></section-f>
            <section-g
                *ngIf="this.currentStep===9"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection9)="handleUpdateFullTeamAssessment($event, 9)"
            ></section-g>
            <section-h 
                *ngIf="this.currentStep===10"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection10)="handleUpdateFullTeamAssessment($event, 10)"
            ></section-h>
            <section-i
                *ngIf="this.currentStep===11"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection11)="handleUpdateFullTeamAssessment($event, 11)"
            ></section-i>
            <section-j
                *ngIf="this.currentStep===12"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection12)="handleUpdateFullTeamAssessment($event, 12)"
            ></section-j>
            <section-k
                *ngIf="this.currentStep===13"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection13)="handleUpdateFullTeamAssessment($event, 13)"
            ></section-k>
            <section-l
                *ngIf="this.currentStep===14"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection14)="handleUpdateFullTeamAssessment($event, 14)"
            ></section-l>
            <section-m
                *ngIf="this.currentStep===15"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection15)="handleUpdateFullTeamAssessment($event, 15)"
            ></section-m>
            <section-n            
                *ngIf="this.currentStep===16"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection16)="handleUpdateFullTeamAssessment($event, 16)"
            ></section-n>
            <full-team-official-signature
                *ngIf="this.currentStep===17"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection17)="handleUpdateFullTeamAssessment($event, 17)"
            ></full-team-official-signature>
            <full-team-submission
                *ngIf="this.currentStep===18"
                class="w-full h-full overflow-y-auto"
                [fullTeamAssessmentData]="this.currentFullTeamAssessment" 
                (onSaveSection18)="handleUpdateFullTeamAssessment($event, 18)"
            ></full-team-submission>
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>

